"use client";

import { useRef, useState, useEffect } from "react";

import HeroSection from "./sections/HeroSection";
import TechnologiesSection from "./sections/TechnologiesSection";
import AboutSection from "./sections/AboutSection";
import ExperienceTimeline from "./sections/ExperienceTimeline";
import ProjectsSection from "./sections/ProjectsSection";
import ContactSection from "./sections/ContactSection";
import Footer from "./sections/Footer";

const throttle = (func, limit) => {
  let inThrottle;
  return function (...args) {
    if (!inThrottle) {
      func.apply(this, args);
      inThrottle = true;
      setTimeout(() => (inThrottle = false), limit);
    }
  };
};

const Portfolio = ({ locale }) => {
  const containerRef = useRef(null);
  const [activeSection, setActiveSection] = useState("about-me");

  useEffect(() => {
    const handleScroll = throttle(() => {
      const sections = ["about-me", "experience", "projects", "contact"];
      const scrollPosition = window.scrollY + window.innerHeight / 2;

      for (const sectionId of sections) {
        const element = document.getElementById(sectionId);
        if (element) {
          const { offsetTop, offsetHeight } = element;
          if (
            scrollPosition >= offsetTop &&
            scrollPosition < offsetTop + offsetHeight
          ) {
            setActiveSection(sectionId);
            break;
          }
        }
      }
    }, 100);

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <main ref={containerRef} className="w-full flex flex-col bg-[#f5f5f5]">
      <HeroSection activeSection={activeSection} locale={locale} />
      <TechnologiesSection locale={locale} />
      <AboutSection locale={locale} />
      <ExperienceTimeline locale={locale} />
      <ProjectsSection locale={locale} />
      <ContactSection locale={locale} />
      <Footer locale={locale} />
    </main>
  );
};

export default Portfolio;
